<template>
  <div class="d-flex" :class="justifyContentClass">
    <button
        type="button"
        :class="btnClass"
        @click="$emit('clicked')"
    >
      {{ text }}
    </button>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: '+'
    },
    btnClass: {
      type: String,
      default: 'btn btn-primary btn-submit-1 custom-p-2 btn-add'
    },
    justifyContentClass: {
      type: String,
      default: 'justify-content-end'
    }
  }
}
</script>
